import React from 'react';
import LoginView from './login-view';

const Login: React.FC = () => {
  return <LoginView />;
};

export default Login;
